// @ts-nocheck
// Exact live version restored from the production sourcemap (portal.rebels.io, 2026-10-23).
import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { Clock, CloseCircle, DocumentText, TickCircle } from 'iconsax-react';
import { HoursTable } from './table/HoursTable';
import { ProfileCard } from './cards/ProfileCard';
import { ActionCard } from './cards/ActionCard';
import { HStatsCard } from './cards/HStatsCard';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getDashboardDetails } from '@application/features/dashboard/dashboardThunk';
import { HoursStatus } from '@application/common/enums/hours-status';
import TimeSheetApi from '@infrastructure/timeSheet-api';
import { useFreelancerTaskCounts } from '@ui/components/freelancer/navebar/useFreelancerTaskCounts';
import '@ui/components/common/micro-interactions/dashboard-motion.scss';
import './freelancer-home.scss';
const plural = (count, singular, pluralLabel) => `${count} ${count === 1 ? singular : pluralLabel}`;
export const FreelancerHome = () => {
    const dispatch = useAppDispatch();
    const { currentUser } = useAppSelector((state) => state.auth);
    const { dashboardDetail } = useAppSelector((state) => state.dashboard);
    useEffect(() => {
        dispatch(getDashboardDetails());
    }, [dispatch]);
    const { openTimeSheets, rejectedTimeSheets, documentsToSign, isLoaded } = useFreelancerTaskCounts();
    const [rejectedPeriods, setRejectedPeriods] = useState([]);
    useEffect(() => {
        // Only when something is rejected: look up which month(s), via the existing hours-by-status API.
        if (!rejectedTimeSheets) {
            setRejectedPeriods([]);
            return;
        }
        let active = true;
        TimeSheetApi.getTimeSheetsUsingStatus(HoursStatus.Rejected)
            .then((response) => {
            const rows = response.data?.timeSheetWithClientInfo ?? [];
            const periods = [...new Set(rows.map((row) => (row.monthName && row.year && !String(row.monthName).includes(String(row.year)) ? `${row.monthName} ${row.year}` : row.monthName || '')).filter(Boolean))];
            if (active)
                setRejectedPeriods(periods);
        })
            .catch(() => {
            if (active)
                setRejectedPeriods([]);
        });
        return () => {
            active = false;
        };
    }, [rejectedTimeSheets]);
    const tasks = [];
    if (rejectedTimeSheets) {
        tasks.push(_jsx(ActionCard, {
            title: 'Correct rejected hours',
            caption: rejectedPeriods.length > 0 ? `Rejected: ${rejectedPeriods.join(', ')}` : plural(rejectedTimeSheets, 'rejected timesheet', 'rejected timesheets'),
            icon: _jsx(CloseCircle, { size: 22 }),
            to: '/hours-logging'
        }, 'rejected'));
    }
    if (openTimeSheets) {
        tasks.push(_jsx(ActionCard, {
            title: 'Fill in your hours',
            caption: `${plural(openTimeSheets, 'open timesheet', 'open timesheets')} to complete`,
            icon: _jsx(Clock, { size: 22 }),
            to: '/hours-logging'
        }, 'open'));
    }
    if (documentsToSign) {
        tasks.push(_jsx(ActionCard, {
            title: 'Sign your documents',
            caption: `${plural(documentsToSign, 'document', 'documents')} waiting for your signature`,
            icon: _jsx(DocumentText, { size: 22 }),
            to: '/documents'
        }, 'documents'));
    }
    if (tasks.length === 0) {
        tasks.push(_jsx(ActionCard, isLoaded
            ? { title: "You're all caught up", caption: 'No open tasks right now', icon: _jsx(TickCircle, { size: 22 }) }
            : { title: 'Checking your tasks…', icon: _jsx(TickCircle, { size: 22 }) }, 'none'));
    }
    return _jsxs('section', {
        className: 'freelancer-home dashboard-enter',
        'aria-labelledby': 'freelancer-home-title',
        children: [
            _jsxs('header', {
                className: 'freelancer-home__header',
                children: [
                    _jsxs('div', {
                        className: 'freelancer-home__greeting',
                        children: [
                            _jsx('p', { className: 'freelancer-home__eyebrow', children: 'Overview' }),
                            _jsxs('h1', {
                                id: 'freelancer-home-title',
                                children: ['Hello', currentUser?.name ? `, ${currentUser.name}` : '']
                            })
                        ]
                    }),
                    _jsx(HStatsCard, {
                        icon: _jsx(Clock, { size: 22 }),
                        title: `Hours recorded in ${moment().locale('en').format('MMMM')}`,
                        color: 'secondary',
                        subtitle: dashboardDetail?.totalMonthlyHours?.toString() ?? '—'
                    })
                ]
            }),
            _jsxs('div', { className: 'freelancer-home__workspace', children: [_jsx(HoursTable, {}), _jsx(ProfileCard, {})] }),
            _jsxs('section', {
                className: 'freelancer-home__todo',
                'aria-labelledby': 'freelancer-home-todo-title',
                children: [
                    _jsx('h2', { id: 'freelancer-home-todo-title', className: 'freelancer-home__todo-title', children: 'To do' }),
                    _jsx('div', { className: 'freelancer-home__actions', children: tasks })
                ]
            })
        ]
    });
};
